import React from 'react';
import { Navbar, Nav, Container, Dropdown, Image } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useParams, useLocation } from "react-router-dom";
import api from "../api";


const HeaderAdmin = ({ page_name, setEvent, onLogout, user, isAuthenticated }) => {
  const [showNavBar, setShowNavBar] = useState(false);
  const companyName = user?.company_name || "My Company";
  const location = useLocation();
  // const page_name = capitalizeFirstLetter(location.pathname.split("/").slice(-1)[0].replace(/-/g, " "));

  const { id_name } = useParams();
  const [loadingEid, setLoadingEid] = useState(false);

  // Retrieve the event data based on the id_name parameter
  const fetchEventName = async () => {
    if (!id_name || !setEvent) return;
    try {
      setLoadingEid(true);
      // Use the environment variable here
        const response = await api.get(
          process.env.REACT_APP_MODEL_ENDPOINT + `/check_eid?id_name=${id_name}`
        );
  
        if (response.data && response.data.success) {
          setEvent(response.data.event);
  
          /** Create click log */
          api.post(
            `click/${response.data.event.event_id}`
            // No body needed; backend extracts headers and IP
          );
  
        } else {
          console.error("invalid event id:", response.data);
          setEvent(false);
        }
      } catch (error) {
        setEvent(false);
      } finally {
        setLoadingEid(false);
      }
  };

  // retrieve the event data based on the id_name parameter
  useEffect(() => {
    fetchEventName();
  }, [id_name]);


  useEffect(() => {
    setShowNavBar(isAuthenticated);
  }, [isAuthenticated]);


  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <>
      <Navbar bg="light" expand="lg" className="mb-2 border-bottom shadow-sm py-2">
        <Container fluid className="d-flex justify-content-between align-items-center">
          {/* Logo on the left */}
          <Navbar.Brand href="/admin" className="ms-2">
            <Image
              src={`${process.env.REACT_APP_MODEL_ENDPOINT}/user_logo?user_id=${user?.user_id}`}
              alt="Logo"
              height="40"
              style={{ borderRadius: "6px" }}
            />
          </Navbar.Brand>

          {/* Right-side navbar */}
          {showNavBar && (
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="outline-secondary"
                id="dropdown-company"
                className="rounded-pill px-3 py-1 shadow-sm fw-semibold"
                style={{ fontSize: "0.95rem" }}
              >
                {companyName}
              </Dropdown.Toggle>

              <Dropdown.Menu className="shadow-sm mt-2">
                <Dropdown.Item href="/admin" className="px-3">
                  Home
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item href="/admin/events" className="px-3">
                  My Events
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={onLogout} className="px-3 text-danger">
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </Container>
      </Navbar>

      {/* Page route name */}
      {page_name !== 'Login' && (
        <div className="mb-2 pb-2 mx-4">
          <h4 className="fw-bold text-secondary">{page_name}</h4>
        </div>
      )}
    </>
  );
};

export default HeaderAdmin;
